import { ProfileAccess } from '@se-po/shared-data-access-profile'
import { PROFILE_MODULE_ORDER, ProfileSidePanelModule } from './profile-side-panel-modules'
import { ProfileSidePanelConfig } from './profile-side-panel.types'

interface ProfileModuleContext {
  access: ProfileAccess
  config: ProfileSidePanelConfig
  isAdmin: boolean
  hasOwner: boolean
}

export const profileModules = ({ access, config, isAdmin, hasOwner }: ProfileModuleContext): ProfileSidePanelModule[] => {
  if (!access.profiles) return []

  const candidates = new Set(config.modules || PROFILE_MODULE_ORDER)

  return PROFILE_MODULE_ORDER
    .filter(module => candidates.has(module))
    .filter(module => moduleAllowed(module, access, isAdmin, hasOwner))
}

const moduleAllowed = (
  module: ProfileSidePanelModule,
  access: ProfileAccess,
  isAdmin: boolean,
  hasOwner: boolean
): boolean => {
  switch (module) {
    case 'dibs':
      return access.dibs && hasOwner
    case 'memberships':
    case 'credentials':
      return access.memberships
    case 'financials':
      return access.financials
    case 'rosterHistory':
      return access.rosterHistory
    case 'permissions':
      return access.admins && isAdmin
    case 'messageHistory':
      return access.messaging
    default:
      return true
  }
}
